import $ from "jquery";
import { sitemap, category, article } from "#templates/pages/sitemap/sitemap_template";
import { AimError } from "#scripts/tools/aimlog.js";
import { getLangForApi } from "#scripts/cmsapi.js";

export const sitemappage = async (navdata) => {
	// Using setTimout to detach from main thread
	setTimeout(() => {
		const allArticlesPromises = traverseSite(navdata);
		Promise.all(allArticlesPromises).then((_) => {
			console.log("Done:");
			document.getElementById("maincontent").innerHTML = sitemap({
				content: buildSiteMap(navdata),
			});
		});
	}, 0);
};

const traverseSite = (navs) => {
	let allArticlesPromises = [];
	for (const nav of navs) {
		const articlesPromise = getArticlesForCategory(nav.categoryId)
			.then((allArticles) => {
				nav._articles = allArticles;
			})
			.catch((error) => {
				console.log("Error:", error);
			});

		allArticlesPromises.push(articlesPromise);

		if (nav.children?.length > 0) {
			const childArticlesPromise = traverseSite(nav.children);
			allArticlesPromises = allArticlesPromises.concat(childArticlesPromise);
		}
	}
	return allArticlesPromises;
};

const buildSiteMap = (navs, _level = 0) => {
	const level = _level + 1;
	let htmlString = "";

	for (const nav of navs) {
		if (nav.previewItem.charAt(0) !== "_") {
			htmlString += category({
				item: nav,
				level,
			});
		}
		nav._articles = nav._articles.listOfContent;
		for (const a of nav._articles) {
			const shouldDisplay = a.contentTypeGuid !== "17c15981-758d-4d09-a7ee-b2d47d2af6f0"; // forsidebilde
			if (shouldDisplay) {
				htmlString += article({
					item: a,
					level,
				});
			}
		}
		if (nav.children?.length > 0) {
			htmlString += buildSiteMap(nav.children, level);
		}
	}
	return htmlString;
};

const getArticlesForCategory = (category) => {
	const config = JSON.parse(sessionStorage.getItem("config"));

	const senddata = JSON.stringify({
		categoryId: category,
		subscriptionId: config.clientId,
	});

	const settings = {
		type: "GET",
	};
	const apiCall = `${window.apiUrl}/Public/articles?subscriptionId=${
		config.clientId
	}&category=${category}&language=${getLangForApi()}&limit=1000&getRecursiveContent=true&sortBy=Title&LanguageMode=Strict`;

	return $.ajax(apiCall, settings)
		.done((data) => data)
		.catch((error) => {
			console.error("Error:", error);
			// AimError('API Error: ' + error.toString(), window.apiUrl + '/PublicContentApi/getbycategoryidasstring');
			AimError(`API Error: ${error.toString()}`, `${window.apiUrl}/Public/articles`);
		});
};
